import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../../core';
import { IMyNotificationsApiClient } from './i-my-notifications-api.client';
import { MyNotificationsApiClient } from './my-notifications.api.client';
import { MyNotificationsInMemoryApiClient } from './my-notifications.api.inmemory.client';

@Injectable({
  providedIn: 'root'
})
export class MyNotificationsApiClientProvider extends ApiClientProvider<IMyNotificationsApiClient> {
  constructor(
    private client: MyNotificationsApiClient,
    private inMemoryClient: MyNotificationsInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IMyNotificationsApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IMyNotificationsApiClient {
    return this.client;
  }
}
